<script setup lang="ts">
import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'
import { gradeConfig } from '@/lib/product'

defineProps<{
    grade: string
    big?: boolean
    iconOnly?: boolean
    abbreviated?: boolean
    plain?: boolean
}>()
</script>

<template>
    <Badge v-if="!plain" variant="outline" :class="cn('gap-1.5 font-medium', big ? '' : 'text-xs')">
        <component
            v-if="!iconOnly"
            :is="gradeConfig[grade]?.icon"
            class="size-3.5"
        />
        {{ abbreviated ? (gradeConfig[grade]?.abbr ?? grade) : (gradeConfig[grade]?.label ?? grade) }}
    </Badge>
    <span v-else class="inline-flex items-center gap-1">
        <component
            v-if="!iconOnly"
            :is="gradeConfig[grade]?.icon"
            class="size-3.5"
        />
        {{ abbreviated ? (gradeConfig[grade]?.abbr ?? grade) : (gradeConfig[grade]?.label ?? grade) }}
    </span>
</template>
